export default __webpack_public_path__ + "static/media/img-utility-left.9b608c10.png";